import { create } from 'zustand'

interface LpAvailabilityPageStore {
  isJpe: boolean
  isMobileScreen: boolean
}

export const useLpAvailabilityPageStore = create<LpAvailabilityPageStore>()((_set, _get) => ({
  isJpe: document.documentElement.lang === 'en',
  isMobileScreen: window.innerWidth < 768,
}))
